(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koya-footer"]) return;
  try {
    
  (() => {
    if (customElements.get('koya-footer-signup')) return;

    // Formulario de correo del footer. La validación, el mensaje de éxito, el botón de copiar
    // y el descuento son los del pop-up (window.KoyaCupon, en sections/koya-popup.liquid).
    class KoyaFooterSignup extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.formPanel = this.querySelector('[data-koya-footer-panel="form"]');
        this.successPanel = this.querySelector('[data-koya-footer-panel="success"]');
        this.errorBox = this.querySelector('[data-koya-footer-error]');
        this.email = this.querySelector('input[type="email"]');
        this.consent = this.querySelector('input[type="checkbox"][required]');
        this.copyButton = this.querySelector('[data-koya-popup-copy]');

        if (this.form) {
          // Validación propia con mensajes en español; sin JS rige la validación nativa
          this.form.noValidate = true;
          this.form.addEventListener('submit', (event) => this.onSubmit(event));
        }
        if (this.copyButton) {
          this.copyButton.addEventListener('click', () => {
            window.KoyaCupon?.copy(this.dataset.discountCode, this.copyButton);
          });
        }

        const postedHere = window.location.hash === `#${this.dataset.formId}`;
        if (!postedHere) return;

        // El JavaScript del pop-up puede cargar después que este: esperar a que esté todo listo
        const run = () => this.afterPost();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', run, { once: true });
        } else {
          run();
        }
      }

      afterPost() {
        if (this.formPanel?.hasAttribute('data-liquid-success')) {
          window.KoyaCupon?.markSubscribed();
          window.KoyaCupon?.apply(this.dataset.discountCode);
          if (this.formPanel) this.formPanel.hidden = true;
          if (this.successPanel) this.successPanel.hidden = false;
        }
        this.scrollIntoView({ block: 'center' });
        this.cleanHash();
      }

      onSubmit(event) {
        const problem = window.KoyaCupon ? window.KoyaCupon.validate(this.email, this.consent) : null;
        if (!problem) return;
        event.preventDefault();
        if (!this.errorBox) return;
        this.errorBox.textContent = problem.message;
        this.errorBox.hidden = false;
        problem.field?.focus();
      }

      cleanHash() {
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('customer_posted');
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }

    customElements.define('koya-footer-signup', KoyaFooterSignup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koya-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('koya-popup')) return;

    const SUBSCRIBED_KEY = 'koyaPopupSubscribed';
    const SEEN_KEY = 'koyaPopupSeen';
    const FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';

    const storage = {
      get(store, key) {
        try {
          return window[store].getItem(key);
        } catch (e) {
          return null;
        }
      },
      set(store, key, value) {
        try {
          window[store].setItem(key, value);
        } catch (e) {}
      },
    };

    // Lógica del cupón compartida entre el pop-up y el formulario del footer
    // (sections/koya-footer.liquid). Este JavaScript se carga en todas las páginas.
    const appliedCodes = new Set();
    window.KoyaCupon = {
      // Recuerda que la persona ya se suscribió, para no volver a mostrarle el pop-up.
      markSubscribed() {
        storage.set('localStorage', SUBSCRIBED_KEY, '1');
      },

      // Deja la cookie del descuento en la sesión sin sacar al usuario de la página
      // (el redirect lo sigue el fetch, no el navegador).
      apply(rawCode) {
        const code = (rawCode || '').trim();
        if (!code || appliedCodes.has(code)) return;
        appliedCodes.add(code);
        fetch('/discount/' + encodeURIComponent(code) + '?redirect=/', { credentials: 'same-origin' }).catch(() => {});
      },

      // Copia el código y cambia el texto del botón a "¡Copiado!".
      copy(rawCode, button) {
        const code = (rawCode || '').trim();
        if (!code) return;
        const done = () => {
          if (button) button.textContent = '¡Copiado!';
        };
        // Plan B para navegadores sin permiso de portapapeles: copiar con un textarea temporal
        const fallback = () => {
          const ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          let ok = false;
          try {
            ok = document.execCommand('copy');
          } catch (e) {}
          ta.remove();
          if (ok) done();
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(fallback);
        } else {
          fallback();
        }
      },

      // Valida correo y consentimiento. Devuelve { message, field } o null si está todo bien.
      validate(email, consent) {
        const emailOk = email && email.value.trim() !== '' && email.checkValidity();
        if (!emailOk) return { message: 'Ingresa un correo electrónico válido.', field: email };
        if (consent && !consent.checked) {
          return { message: 'Para recibir tu cupón, acepta recibir correos de Koya.', field: consent };
        }
        return null;
      },
    };

    class KoyaPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.koya-popup__dialog');
        this.form = this.querySelector('form');
        this.formPanel = this.querySelector('[data-koya-popup-panel="form"]');
        this.successPanel = this.querySelector('[data-koya-popup-panel="success"]');
        this.errorBox = this.querySelector('[data-koya-popup-error]');
        this.consent = this.querySelector('input[type="checkbox"][required]');
        this.email = this.querySelector('input[type="email"]');
        this.designMode = this.dataset.designMode === 'true';
        this.previousFocus = null;
        this.cleanups = [];

        this.onKeydown = this.onKeydown.bind(this);
        this.on(this, 'click', (event) => {
          if (event.target.closest('[data-koya-popup-close]')) this.close();
        });
        if (this.form) {
          // Validación propia con mensajes en español; sin JS rige la validación nativa
          this.form.noValidate = true;
          this.on(this.form, 'submit', (event) => this.onSubmit(event));
        }
        if (this.consent) this.on(this.consent, 'change', () => this.clearError());
        this.copyButton = this.querySelector('[data-koya-popup-copy]');
        if (this.copyButton) this.on(this.copyButton, 'click', () => this.copyCode());

        const formId = this.dataset.formId;
        const postedHere = window.location.hash === `#${formId}`;
        const liquidSuccess = this.formPanel?.hasAttribute('data-liquid-success');
        const liquidErrors = this.formPanel?.hasAttribute('data-liquid-errors');

        if (this.dataset.forceOpen === 'true') {
          this.hidden = false;
          this.classList.add('is-open');
          return;
        }

        if (this.designMode) {
          this.on(document, 'shopify:section:select', (event) => {
            if (this.closest(`#shopify-section-${event.detail.sectionId}`)) this.open(false);
          });
          this.on(document, 'shopify:section:deselect', (event) => {
            if (this.closest(`#shopify-section-${event.detail.sectionId}`)) this.close();
          });
          return;
        }

        if (postedHere && liquidSuccess) {
          storage.set('localStorage', SUBSCRIBED_KEY, '1');
          this.applyDiscount();
          this.showSuccess();
          this.open();
          this.cleanHash();
          return;
        }

        if (postedHere && liquidErrors) {
          this.open();
          this.cleanHash();
          return;
        }

        if (storage.get('localStorage', SUBSCRIBED_KEY)) return;
        if (storage.get('sessionStorage', SEEN_KEY)) return;

        this.setupTriggers();
      }

      disconnectedCallback() {
        this.teardownTriggers();
        this.cleanups.forEach((fn) => fn());
        this.cleanups = [];
        this.unlock();
      }

      on(target, type, handler, options) {
        target.addEventListener(type, handler, options);
        this.cleanups.push(() => target.removeEventListener(type, handler, options));
      }

      setupTriggers() {
        const delay = parseFloat(this.dataset.delay);
        const scroll = parseFloat(this.dataset.scroll);

        if (delay >= 0) {
          this.timer = window.setTimeout(() => this.trigger(), delay * 1000);
        }

        if (scroll >= 0) {
          this.onScroll = () => {
            const doc = document.documentElement;
            const scrollable = doc.scrollHeight - window.innerHeight;
            const percent = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 100;
            if (percent >= scroll) this.trigger();
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }
      }

      teardownTriggers() {
        window.clearTimeout(this.timer);
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        this.onScroll = null;
      }

      trigger() {
        this.teardownTriggers();
        if (this.isOpen) return;
        // No interrumpir si hay otro modal abierto del tema
        if (document.querySelector('dialog[open]')) {
          this.timer = window.setTimeout(() => this.trigger(), 5000);
          return;
        }
        storage.set('sessionStorage', SEEN_KEY, '1');
        this.open();
      }

      get isOpen() {
        return this.classList.contains('is-open');
      }

      open(moveFocus = true) {
        if (this.isOpen) return;
        this.previousFocus = document.activeElement;
        this.hidden = false;
        // Forzar reflow para que la transición de opacidad se ejecute
        void this.offsetWidth;
        this.classList.add('is-open');
        this.lock();
        document.addEventListener('keydown', this.onKeydown);
        if (moveFocus) {
          const target = this.successPanel && !this.successPanel.hidden ? this.successPanel : this.dialog;
          target.focus({ preventScroll: true });
        }
      }

      close() {
        if (!this.isOpen) return;
        this.classList.remove('is-open');
        document.removeEventListener('keydown', this.onKeydown);
        this.unlock();

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.setTimeout(() => {
          if (!this.isOpen) this.hidden = true;
        }, reduceMotion ? 0 : 300);

        if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
          this.previousFocus.focus({ preventScroll: true });
        }
        this.previousFocus = null;
      }

      lock() {
        if (this.designMode) return;
        document.body.classList.add('koya-popup-lock');
      }

      unlock() {
        document.body.classList.remove('koya-popup-lock');
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;

        const focusable = [...this.dialog.querySelectorAll(FOCUSABLE)].filter(
          (el) => el.offsetParent !== null || el === document.activeElement
        );
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;

        if (!this.dialog.contains(active)) {
          event.preventDefault();
          first.focus();
        } else if (event.shiftKey && (active === first || active === this.dialog)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && active === last) {
          event.preventDefault();
          first.focus();
        }
      }

      onSubmit(event) {
        const problem = window.KoyaCupon.validate(this.email, this.consent);
        if (!problem) return;
        event.preventDefault();
        this.showError(problem.message, problem.field);
      }

      showError(message, field) {
        if (!this.errorBox) return;
        this.errorBox.textContent = message;
        this.errorBox.hidden = false;
        if (field) {
          field.setAttribute('aria-invalid', 'true');
          field.focus();
        }
      }

      clearError() {
        if (!this.errorBox) return;
        this.errorBox.hidden = true;
        this.errorBox.textContent = '';
        this.querySelectorAll('[aria-invalid]').forEach((el) => el.removeAttribute('aria-invalid'));
      }

      showSuccess() {
        if (this.formPanel) this.formPanel.hidden = true;
        if (this.successPanel) this.successPanel.hidden = false;
      }

      applyDiscount() {
        window.KoyaCupon.apply(this.dataset.discountCode);
      }

      copyCode() {
        window.KoyaCupon.copy(this.dataset.discountCode, this.copyButton);
      }

      cleanHash() {
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('customer_posted');
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }

    customElements.define('koya-popup', KoyaPopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
